import React from 'react';
import PropTypes from 'prop-types';
import MainTitle from 'base/components/MainTitle/index';
import { closeModal } from 'modal/store/actions';
import { useAppDispatch } from 'store/hooks';
import { useGetMyContactQuery, useUpdateMyContactMutation } from 'contacts/store/contactService';
import Loader from 'base/components/Loader';
import toast from 'base/components/Toast/toast';
import ContactForm from './ContactForm';

export default function UpdateContactModal({ name }) {
  const dispatch = useAppDispatch();
  const { data: contact, isLoading } = useGetMyContactQuery();
  const [updateMyContact] = useUpdateMyContactMutation();
  return (
    <>
      <MainTitle withSpaceBelow>Edit my contact info</MainTitle>
      <Loader isLoading={isLoading}>
        <ContactForm
          contact={contact}
          onSubmit={async contactValues => {
            try {
              const updatedContact = {
                ...contact,
                ...contactValues,
              };
              await updateMyContact({
                contact: updatedContact,
                image: contactValues?.imageFile[0]?.fileObject || null,
              }).unwrap();
              toast.success('Successfully updated contact');
              dispatch(closeModal(name));
            } catch (error) {
              toast.error('Error updating contact');
            }
          }}
        />
      </Loader>
    </>
  );
}
UpdateContactModal.propTypes = {
  name: PropTypes.string.isRequired,
};
